/* Circles */
/* -------------------------------------------- */
function circularText() {
    Splitting({
        whitespace: true
    })
}

circularText();
